import React, { useMemo } from "react"


import {
  formatDayHeaderLabel,
  toISODate,
  isSameDay,
} from "../../../utils/date"
import GradeEventCard from "./GradeEventCard"

import { useGradeGrid } from "../hooks/useGradeGrid"

const GradeGrid = ({
  turn,
  view,
  referenceDate,
  weekStart: weekStartProp,
  schedules,
  onSelectSchedule,
  selectedScheduleId,
  selectedScheduleIds,
  selectedScheduleKey,
  onToggleSelection,
  selectedClassId,
  // Novos props para modo de seleção (matrícula)
  mode = 'view', // 'view' | 'selection'
  selectedSession = null,
  isClassSelected = null,
  isClassEnrolled = null, // Nova prop para indicar turmas já matriculadas
}) => {
  const { days, timeRows, getCellSchedules } = useGradeGrid({
    turn,
    view,
    referenceDate,
    weekStartProp,
    schedules
  })

  const selectedSet = useMemo(() => {
    return new Set((Array.isArray(selectedScheduleIds) ? selectedScheduleIds : []).map(String))
  }, [selectedScheduleIds])

  return (
    <div className="grade-grid table-responsive position-relative">
      <div
        className="grade-grid__inner"
        style={{
          display: "grid",
          gridTemplateColumns: `56px repeat(${days.length}, minmax(100px, 1fr))`,
          minWidth: "100%",
          opacity: 1,
        }}
      >
        <div className="grade-grid__corner" />
        {days.map(d => (
          <div
            key={toISODate(d)}
            className={`grade-grid__header ${isSameDay(d, referenceDate) ? "is-today" : ""}`}
          >
            {formatDayHeaderLabel(d)}
          </div>
        ))}

        {timeRows.map(t => (
          <React.Fragment key={t.label}>
            <div className="grade-grid__time">{t.label}</div>
            {days.map(d => {
              const iso = toISODate(d)
              const cellSchedules = getCellSchedules(iso, t.label)


              const selected = isSameDay(d, referenceDate)

              return (
                <div
                  key={`${iso}-${t.label}`}
                  className={`grade-grid__cell ${selected ? "is-reference" : ""}`}
                >
                  {cellSchedules.filter(Boolean).map(s => (
                    <div key={s.idSession || s.id || `${s.startTime}-${s.activityName || ""}`} className="mb-2">
                      <GradeEventCard
                        schedule={s}
                        onClick={
                          onToggleSelection
                            ? () => onToggleSelection(s, iso)
                            : onSelectSchedule
                              ? () => onSelectSchedule(s, iso)
                              : undefined
                        }
                        isSelected={
                          mode === 'selection'
                            ? (isClassSelected ? isClassSelected(s) : false)
                            : selectedClassId
                              ? String(s.idClass) === String(selectedClassId)
                              : selectedScheduleKey
                                ? selectedScheduleKey === `${String(s.id)}|${iso}`
                                : selectedSet.size > 0
                                  ? selectedSet.has(String(s.id))
                                  : selectedScheduleId
                                    ? String(s.id) === selectedScheduleId
                                    : false
                        }
                        selectionMode={mode === 'selection'}
                        selectionType={selectedSession === s.id ? 'trial' : 'regular'}
                        isEnrolled={isClassEnrolled ? isClassEnrolled(s) : false}
                      />
                    </div>
                  ))}
                </div>
              )
            })}
          </React.Fragment>
        ))}
      </div>

    </div>
  )
}

export default GradeGrid
